import { ALLOWED_DAYS, type BadgeTheme, MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL } from 'src/features/memberships/types/';
import { membershipMessages } from 'src/features/memberships/utils/messages';
import { generalMessagesDays } from 'src/utils/messages';

import type { BadgeOptions } from 'src/types/ui';

const badgeAllowedDaysOptions: BadgeOptions = {
    [ALLOWED_DAYS.monday]: {
        label: generalMessagesDays.monday,
    },
    [ALLOWED_DAYS.tuesday]: {
        label: generalMessagesDays.tuesday,
    },
    [ALLOWED_DAYS.wednesday]: {
        label: generalMessagesDays.wednesday,
    },
    [ALLOWED_DAYS.thursday]: {
        label: generalMessagesDays.thursday,
    },
    [ALLOWED_DAYS.friday]: {
        label: generalMessagesDays.friday,
    },
    [ALLOWED_DAYS.saturday]: {
        label: generalMessagesDays.saturday,
    },
    [ALLOWED_DAYS.sunday]: {
        label: generalMessagesDays.sunday,
    },
};

const allowedDaysOptions = [
    { label: generalMessagesDays.monday, value: ALLOWED_DAYS.monday },
    { label: generalMessagesDays.tuesday, value: ALLOWED_DAYS.tuesday },
    { label: generalMessagesDays.wednesday, value: ALLOWED_DAYS.wednesday },
    { label: generalMessagesDays.thursday, value: ALLOWED_DAYS.thursday },
    { label: generalMessagesDays.friday, value: ALLOWED_DAYS.friday },
    { label: generalMessagesDays.saturday, value: ALLOWED_DAYS.saturday },
    { label: generalMessagesDays.sunday, value: ALLOWED_DAYS.sunday },
];

const badgeAccessLevelOptions: BadgeOptions = {
    admin: {
        label: membershipMessages.accessLevelAdmin,
        theme: 'sky',
    },
    member: {
        label: membershipMessages.accessLevelMember,
        theme: 'emerald',
    },
    guest: {
        label: membershipMessages.accessLevelGuest,
        theme: 'indigo',
    },
};
export enum VEHICLE_PARKING_STATUS {
    IN_PARKING = 'inParking',
    OUT_OF_PARKING = 'outOfParking',
}
export const badgeMembershipCardOptions: BadgeOptions = {
    [VEHICLE_PARKING_STATUS.IN_PARKING]: {
        label: membershipMessages.inParking,
        theme: 'green',
    },
    [VEHICLE_PARKING_STATUS.OUT_OF_PARKING]: {
        label: membershipMessages.outOfParking,
        theme: 'red',
    },
};

const accessLevelOptions = [
    { label: membershipMessages.accessLevelAdmin, value: MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL.ADMIN },
    { label: membershipMessages.accessLevelMember, value: MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL.MEMBER },
    { label: membershipMessages.accessLevelGuest, value: MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL.GUEST },
];

const ALL_POINTS_OPTION = '#ALL#';
const START_FULL_DAY = '00:00:00';
const END_FULL_DAY = '23:59:59';

const badgeThemes: BadgeTheme[] = [
    'gray',
    'red',
    'orange',
    'yellow',
    'lime',
    'emerald',
    'cyan',
    'blue',
    'indigo',
    'violet',
    'purple',
    'fuchsia',
];

export {
    badgeAllowedDaysOptions,
    allowedDaysOptions,
    badgeAccessLevelOptions,
    accessLevelOptions,
    badgeThemes,
    ALL_POINTS_OPTION,
    START_FULL_DAY,
    END_FULL_DAY,
};
